// extracted by css-extract-rspack-plugin
export default {"tooltip":"CopyToClipboardIconButton-module__tooltip__WyiwL"};